<template>
  <div class="">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <!-- Table Container -->
          <div class="page-load-main-container">
            <!-- Header inside the container -->
            <div class="row">
              <div class="col-md-12">
                <div class="page-load-header">
                  <h2 class="page-load-title custom-font-32">{{ monitor_data.type == 7 ? 'Page Screenshot Data' : 'Page Speed Data' }}</h2>
                  <div class="page-load-per-page-wrapper">
                    <img src="../assets/icons/per-page.svg" alt="Per page" class="per-page-icon mr-2" />
                    <span>Per page : </span>
                    <div class="select-wrapper">
                      <b-form-select
                        class="page-load-per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        @change="getPageloadData()"
                      >
                      </b-form-select>
                      <i class="icofont icofont-simple-down select-icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Table Container with padding -->
            <div class="row">
              <div class="col-md-12">
                <div class="page-load-table-container table-responsive-custom datatable-vue text-left">
                  <div v-if="loading">
                    <div class="loader-box">
                      <div class="loader-30"></div>
                    </div>
                  </div>
                  <b-table
                    v-else
                    class="page-load-table custom-font-20"
                    borderless
                    show-empty
                    stacked="md"
                    :items="pageload_data"
                    :fields="tablefields"
                    :per-page="perPage"
                    :current-page="currentPage"
                  >
                  <template #table-caption>Page Reload data.</template>
                  <template #cell(mName)="data">
                     <!-- {{ monitor_list[data.item.mid] }} -->
                    {{ monitor_data.name }}
                  </template>
                  <template #cell(screenshot)="data">
                    <span class="text-primary" @click="ImageModal(data.item)"><feather type="image"></feather></span>
                  </template>
                  <template #cell(createdAt)="data">
                    <span class="">{{changeDateFormate(data.item.createdAt)}}</span>
                  </template>
                  </b-table>
                </div>
              </div>
            </div>
                    
            <!-- Pagination Component -->
            <pagination-component
              class="pr-0 pl-0 border-0"
              :current-page="currentPage"
              :per-page="perPage"
              :total-items="totalRowsCount || totalRows"
              :page-options="pageOptions"
              @change-page="handlePageChange"
              @update-per-page="handlePerPageChange"
            />
          </div>
          <!-- Screenshot Modal -->
          <b-modal id="modal-image" size="xl" title="Page Screen Shot" class="theme-modal" v-model="image_modal" no-close-on-backdrop hide-footer>
            <b-row>
              <b-col class="text-center">
                <div v-if="load_img">
                  <div class="loader-box">
                    <div class="loader-30"></div>
                  </div>
                </div>
                <div v-else>
                  <img :src="'data:image/png;base64,'+image_data" style="max-width: 100%;max-height: 100%;" />
                </div>
              </b-col>
            </b-row>
            <template #modal-footer>
              <b-button @click="(image_modal = false)" color="danger">Close</b-button>
            </template>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>
  
  
<script>
import moment from 'moment'
import DashboardController from "../../services/dashboardController";
import PaginationComponent from '../components/PaginationComponent.vue';
export default {
  name: "Event",
  components: {
    PaginationComponent
  },
  props:{monitor_id:String,monitor_data:Object,dateRanges:Object,update_filter:Number},
  data() {
    return {
      load_img:false,
      image_data:[],
      image_modal:false,
      pageload_data: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 50],
      loading: false,
      totalRowsCount: 0,
      tablefields: [
        { key: "mName", label: "Name", sortable: true },
        { key: "RecalcStyleDuration", label: "Recalc Style Duration", sortable: false },
        { key: "ScriptDuration", label: "Script Duration", sortable: false },
        { key: "TaskDuration", label: "Task Duration", sortable: false },
        { key: "JSHeapTotalSize", label: "JSHeap TotalSize", sortable: false },
        { key: "createdAt", label: "Started At", sortable: false },
      ]
    };
  },
  mounted() {
    if(this.monitor_data.type == 7){
      this.tablefields.push({ key: "screenshot", label: "Screenshot", sortable: false })
    }
    this.getPageloadData();
  },
  watch:{
    monitor_id(){
      this.currentPage = 1
      this.getPageloadData()
    },
    update_filter(){
        this.getPageloadData(this.dateRanges)
    }
  },
  methods: {
    handlePageChange(direction) {
      if (direction === 'prev' && this.currentPage > 1) {
        this.currentPage--;
      } else if (direction === 'next') {
        this.currentPage++;
      }
      this.getPageloadData();
    },
    handlePerPageChange(newPerPage) {
      this.perPage = newPerPage;
      this.currentPage = 1;
      this.getPageloadData();
    },
    async ImageModal(data){
      this.image_modal = true
      this.load_img = true
      let response = await DashboardController.getPageloadImage({"pageid": data._id});
      this.load_img=false
      this.image_data = this.arrayBufferToBase64(response.data.screenshot.data)
    },
    arrayBufferToBase64( buffer ) {
    var binary = '';
    var bytes = new Uint8Array( buffer );
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
    },
    changeDateFormate(d){
        return moment(d).format('D/M/YYYY, hh:mm A')
    },
    async getPageloadData(dateRange) {
      let payload = { "mid": this.monitor_id}
      if(dateRange){
            payload.sdate = dateRange.startDate
            payload.edate = dateRange.endDate
        }
      this.loading = true;
      // this.monitor_list = [];
      // for(var i=0; i<this.monitor_data.length; i++){
      //   this.monitor_list[this.monitor_data[i].value]=this.monitor_data[i].text
      // }
      let response = await DashboardController.getPageloadData(payload);
      if (response.result) {
        this.pageload_data = [];
        this.pageload_data = response.data;
        this.totalRows = this.pageload_data.length;
        this.totalRowsCount = response.totalCount || response.total || response.count || this.pageload_data.length;
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
/* Main wrapper */
.page-load-data-wrapper {
  padding: 20px 0;
  background: #F8F9FA;
  min-height: 100vh;
}

/* Main container matching dashboard incidents */
.page-load-main-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 0 20px 20px 20px;
  position: relative;
}

/* Header inside container */
.page-load-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0;
  flex-wrap: wrap;
  gap: 20px;
}

/* Title styling */
.page-load-title {
  font-family: 'Poppins', sans-serif;
  font-size: 32px;
  font-weight: 600;
  color: #161616;
  margin: 0;
}

/* Per page selector matching incidents */
.page-load-per-page-wrapper {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  padding: 0 16px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  height: 48px;
}

.page-load-per-page-wrapper .per-page-icon {
  width: 16px;
  height: 18px;
}

.page-load-per-page-wrapper .select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.page-load-per-page-select {
  width: auto;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  padding: 0 20px 0 5px;
  color: #344054;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.page-load-per-page-select:focus {
  outline: none;
  box-shadow: none;
}

.page-load-per-page-wrapper .select-icon {
  position: absolute;
  right: 2px;
  pointer-events: none;
  color: #344054;
}

/* Table container */
.page-load-table-container {
  width: 100%;
  overflow: hidden;
  margin-bottom: 0;
}

/* Table styling matching dashboard incidents */
.page-load-table {
  margin-bottom: 0;
  width: 100%;
  border: none !important;
  border-radius: 0 !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  font-family: 'Poppins', sans-serif;
}

.page-load-table >>> thead th {
  background: #FFFFFF;
  padding: 30px 20px 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  font-size: 18px;
  color: #161616 !important;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
  text-transform: none;
  white-space: nowrap;
}

.page-load-table >>> thead th:first-child {
  padding-left: 20px !important;
}

.page-load-table >>> thead th:last-child {
  padding-right: 20px !important;
}

.page-load-table >>> tbody tr {
  border: none;
}

.page-load-table >>> tbody tr td {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #161616;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
  vertical-align: middle;
}

.page-load-table >>> tbody tr:last-child td {
  border-bottom: none !important;
}

.page-load-table >>> tbody tr:hover {
  background-color: #F9FAFB;
}

.page-load-table >>> tbody td:first-child {
  padding-left: 20px !important;
}

.page-load-table >>> tbody td:last-child {
  padding-right: 20px !important;
}

/* Screenshot icon */
.page-load-table .text-primary {
  cursor: pointer;
  color: #2563EB !important;
}

.page-load-table .text-primary:hover {
  color: #1d4ed8 !important;
}

/* Pagination styling */
.page-load-main-container .custom-pagination {
  margin-top: 0;
  border: none;
  border-radius: 0 0 20px 20px;
  border-top: none;
}

/* Loader */
.loader-box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Responsive */
@media (max-width: 768px) {
  .page-load-main-container {
    padding: 0 10px 10px 10px;
  }

  .page-load-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  }

  .page-load-per-page-wrapper {
    width: 100%;
    justify-content: center;
  }

  .page-load-title {
    font-size: 24px;
  }

  .page-load-table >>> thead th,
  .page-load-table >>> tbody td {
    padding: 12px 15px !important;
  }

  .page-load-table >>> thead th:first-child,
  .page-load-table >>> tbody td:first-child {
    padding-left: 15px !important;
  }

  .page-load-table >>> thead th:last-child,
  .page-load-table >>> tbody td:last-child {
    padding-right: 15px !important;
  }
}

/* Empty state */
.page-load-table .b-table-empty-row td {
  text-align: center;
  padding: 48px 24px;
  color: #667085;
  font-size: 16px;
  font-family: 'Poppins', sans-serif;
}
</style>